import { apiRequest } from './http';
import { getDeviceMeta } from '../helpers/device';
import type { ApiEnvelope, LoginResponse } from '../types/api';

// POST login with a dashboard-issued code for an existing device.
// Returns the same shape as pairing completion (device + token + config).
export async function loginWithCode(code: number): Promise<LoginResponse> {
  const res = await apiRequest<ApiEnvelope<LoginResponse>>('login', {
    method: 'POST',
    body: { code, ...(await getDeviceMeta()) },
    auth: false,
  });
  if (!res.data?.token) throw new Error(res.message ?? 'Login failed.');
  return res.data;
}
